import React from 'react';

const address = () => {
    return (
        <div>
            <h1>Address</h1>
        </div>
    );
};

export default address;